const getCommonEventProps = ({
    elementName,
    buyerId,
    listId,
    componentName,
    type,
}: {
    elementName: string;
    buyerId: string;
    listId?: string;
    componentName: string;
    type: 'imp' | 'user_actions';
}) => ({
    group: type === 'imp' ? 'user_impression' : 'user_actions',
    buyer: {
        id: buyerId,
    },
    page: {
        element: {
            name: elementName,
        },
        component: {
            componentName,
            listId: listId || null,
        },
    },
    action: {
        type: type === 'imp' ? 'imp' : 'click',
    },
    matchmaking_tool: {
        id: listId,
    },
});

export const bqEvents = {
    viewed_recommendations_list({ elementName, buyerId, listId, componentName }) {
        return {
            ...getCommonEventProps({ elementName, buyerId, listId, componentName, type: 'imp' }),
            type: 'view_recommendations_list',
        };
    },
    viewed_seller_recommendations_list({ elementName, buyerId, listId, componentName }) {
        return {
            ...getCommonEventProps({ elementName, buyerId, listId, componentName, type: 'imp' }),
            type: 'view_seller_recommendations_list',
        };
    },
    viewed_gigs_recommendations_list({ elementName, buyerId, listId, componentName }) {
        return {
            ...getCommonEventProps({ elementName, buyerId, listId, componentName, type: 'imp' }),
            type: 'view_gig_recommendations_list',
        };
    },
    saved_list({ elementName, buyerId, listId, componentName }) {
        return {
            ...getCommonEventProps({ elementName, buyerId, listId, componentName, type: 'user_actions' }),
            type: 'saved_list',
        };
    },
};
